<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime : 2020-01-07 11:10:06
 * @LastEditors  : Please set LastEditors
 -->
<template>
    <div id="page_Container">
        <div class="page">
            <div id='main-container' class='orderBox main-container' style="height: 100%;">
                <van-tabs @change='changeTab' v-model="active">
                    <van-tab v-for="(item, index) in tabList" :title="item" :key='item'>
                        <van-pull-refresh :class="{flexClass:!listShow}" v-model="isLoading" @refresh="onRefresh" class='refreshBox'>
                            <van-list v-model="ploading" :finished="finished" @load="onLoad">
                                <span slot='loading' class='mt20' v-if='loadingTextShow'>加载中...</span>
                                <span slot='loading' class='mt20' v-if='!loadingTextShow'></span>
                                <div class='orderList' v-if="listShow" v-for='item in orderList' :key='item.id'>
                                    <p class='orderType'>
                                        <img class='kdImg' :src="kd" alt="" v-if='item.deliveryMethodCode === "EXPRESS_DELIVERY"'>
                                        <img :src="ps" alt="" v-if='item.deliveryMethodCode === "EXPRESS_DISTRIBUTION"'>
                                        <img :src="zt" alt="" v-if='item.deliveryMethodCode === "COME_ON"'>
                                        <img :src="zy" style='margin-top:2px;' alt="" v-if='item.deliveryMethodCode === "TRANSPORT_DIRECT"'>
                                        <span class='type' v-if='item.businessType === 1'>{{item.businessTypeStr + item.deliveryMethod}}</span>
                                        <span class='type' v-if='item.businessType === 2'>{{item.businessTypeStr + '-' + item.supplierName}}</span>
                                        <span class='status'>{{item.statusStr}}</span>
                                    </p>
                                    <div @click='openOrderDetails(item.orderCode)'>
                                        <van-card :title="cardItem.productName" :thumb="cardItem.productImg" v-for='cardItem in item.memberOrderItemList' :key='cardItem.id'>
                                            <template slot='desc'>
                                                <p class='descP'>{{cardItem.specificationValue}}</p>
                                                <p class='numP'>
                                                    <span class='span1'>￥{{ESVBase.numberTofixed(cardItem.productPrice)}}</span>
                                                    <span class='span2'>×{{cardItem.quantity}}</span>
                                                </p>
                                                <div class='divBox'>
                                                    <p class='floatLeft zyStyle'>
                                                        {{item.businessTypeStr}}
                                                    </p>
                                                </div>
                                            </template>
                                        </van-card>
                                    </div>
                                    <div class='paymentMessage'>
                                        共{{item.memberOrderItemList && item.memberOrderItemList.length}}件商品 合计：¥{{ESVBase.numberTofixed(item.payAmount)}}（含运费¥{{item.freightAmount === undefined || item.freightAmount === 0 ? 0 : ESVBase.numberTofixed(item.freightAmount)}}）
                                    </div>
                                    <div class='buttonStyle'>
                                        <div v-if='item.status === "10"'>
                                            <BtnAss :text='textParentCancel' :type='1'
                                            :disabled='index === currentIdx ? disabled : false'
                                            @fromChildClick='cancelOrder(item, index)'></BtnAss>
                                            <BtnAss :text='payParent' v-if='item.type === 1' :type='2' @fromChildClick='paymentClick(item)'></BtnAss>
                                        </div>
                                        <!-- TODO 提醒发货 -->
                                        <!-- <div v-if='item.status === "20"'>
                                            <BtnAss :text='txText' :type='2' @fromChildClick='shipmentClick(item)'></BtnAss>
                                        </div> -->
                                        <div v-if='item.status === "40"'>
                                            <BtnAss :text='watchWl' v-if='item.deliveryMethodCode !== "COME_ON"' :type='1' @fromChildClick='queryLogistics(item)'></BtnAss>
                                            <BtnAss :text='okProduct' :type='2' @fromChildClick='collectGoods(item)'></BtnAss>
                                        </div>
                                        <div v-if='item.status === "50"'>
                                            <BtnAss :text='watchWl' :type='1' v-if='item.deliveryMethodCode !== "COME_ON"' @fromChildClick='queryLogistics(item)'></BtnAss>
                                            <BtnAss :text='deleteText' :type='1' @fromChildClick='deleteOrder(item)'></BtnAss>
                                            <BtnAss :text='pjText' :type='2' @fromChildClick='openEvaluate(item)'></BtnAss>
                                        </div>
                                        <div v-if='item.status === "60"'>
                                            <BtnAss :text='deleteText' :type='1' @fromChildClick='deleteOrder(item)'></BtnAss>
                                        </div>
                                        <div v-if='item.status === "70"'>
                                            <BtnAss :text='deleteText' :type='1' @fromChildClick='deleteOrder(item)'></BtnAss>
                                            <BtnAss :text='watchWl' v-if='item.deliveryMethodCode !== "COME_ON"' :type='1' @fromChildClick='queryLogistics(item)'></BtnAss>
                                        </div>
                                    </div>
                                </div>
                            </van-list>
                            <div v-if='!listShow' class='noListStyle'>
                                <img :src="noListUrl" alt="">
                                <p>暂无订单！</p>
                            </div>
                        </van-pull-refresh>
                    </van-tab>
                </van-tabs>
            </div>
        </div>
    </div>
</template>
<script>
import * as orderStatusConst from '@/assets/js/const.js';
import { Dialog, Toast } from 'vant';
import BtnAss from '@/components/common/btnAss';
import { toastLoading, clearToastLoading, confirmModal } from '@/utils/base/utils';
import { mapMutations } from 'vuex';
export default {
    components: {
        Dialog,
        Toast,
        BtnAss
    },
    data() {
        return {
            orderStatusConst,
            currentIdx: -1,
            disabled: false,
            textParentCancel: '取消订单',
            payParent: '付款',
            txText: '提醒发货',
            watchWl: '查看物流',
            okProduct: '确认收货',
            deleteText: '删除订单',
            pjText: '评价',
            tabList: ['全部', '待付款', '待发货', '待收货', '待评价'],
            active: 0,
            commodityUrl: require('../assets/img/myCenter/commodity.png'),
            noListUrl: require('../assets/img/myCenter/noList.png'),
            ploading: false,
            finished: true,
            pageNum: 1,
            pageSize: 5,
            status: '',
            orderList: [],
            listShow: true,
            isLoading: false,
            loadingTextShow: true,
            ps: require('../assets/img/myCenter/ps.png'),
            kd: require('../assets/img/myCenter/kd.png'),
            zt: require('../assets/img/myCenter/zt.png'),
            zy: require('../assets/img/myCenter/zy.png')
        };
    },
    esvReady: function() {

    },
    esvShow: function() {
        const ths = this;
        document.title = '我的订单';
        this.ESVStorage.getSavedValue('status', (data) => {
            this.status = data;
            if (this.status === '') {
                this.active = 0;
            } else if (this.status === '10') {
                this.active = 1;
            } else if (this.status === '20') {
                this.active = 2;
            } else if (this.status === '40') {
                this.active = 3;
            } else if (this.status === '50') {
                this.active = 4;
            } else {
                this.active = Number(this.status);
            }
        });
        this.ESVStorage.getSavedValue('oldStatus', (data) => {
            // 全部商品进去 oldStatus 有值为 all
            if (data === 'all') {
                ths.ESVStorage.putSavedValue('status', '');
                ths.status = '';
            }
            ths.ESVStorage.removeSavedValue('oldStatus');
        });
        ths.pageNum = 1;
        ths.orderList = [];
        ths.queryMemberOrderList();
        window.addEventListener('popstate', function(e) {
            if (e.target.location.hash === '#/OPMyOrder') {
                ths.esvOpenPage('COMembercenter');
            }
        });
    },
    methods: {
        ...mapMutations(['setOrderDetails']),
        // 请求列表
        queryMemberOrderList() {
            const ths = this;
            this.ESVStorage.getSavedValue('status', (data) => {
                ths.status = data;
            });
            const params = {
                pageNum: ths.pageNum,
                pageSize: ths.pageSize,
                status: ths.status
            };
            ths.listShow = true;
            ths.$doRequest(
                {
                    url: '/order/queryMemberOrderList',
                    params: params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        ths.finished = true;
                        ths.ploading = false;
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    try {
                        const total = parseInt(data.result.total);
                        ths.orderList =
                            ths.pageNum === 1
                                ? data.result.list
                                : [...ths.orderList, ...data.result.list];

                        if (ths.orderList && ths.orderList.length < total) {
                            ths.finished = false;
                        } else {
                            ths.finished = true;
                        }

                        if (ths.orderList && ths.orderList.length > 0) {
                            ths.listShow = true;
                        } else {
                            ths.listShow = false;
                        }
                    } catch (error) {
                        console.log(222);
                        alert(error);
                    }
                }
            );
        },
        onLoad() {
            this.pageNum++;
            this.queryMemberOrderList();
        },
        onRefresh() {
            setTimeout(() => {
                this.pageNum = 1;
                this.queryMemberOrderList();
                this.loadingTextShow = false;
                this.isLoading = false;
            }, 500);
        },
        changeTab(index, title) {
            setTimeout(() => {
                this.orderList = [];
            }, 20);
            if (title === '全部') {
                this.ESVStorage.putSavedValue(
                    'status',
                    ''
                );
            } else if (title === '待付款') {
                this.ESVStorage.putSavedValue(
                    'status',
                    this.orderStatusConst.unpay
                );
            } else if (title === '待发货') {
                this.ESVStorage.putSavedValue(
                    'status',
                    this.orderStatusConst.toDeliver
                );
            } else if (title === '待收货') {
                this.ESVStorage.putSavedValue(
                    'status',
                    this.orderStatusConst.pendingReceipt
                );
            } else if (title === '待评价') {
                this.ESVStorage.putSavedValue(
                    'status',
                    this.orderStatusConst.comment
                );
            }
            this.loadingTextShow = true;
            this.pageNum = 1;
            this.queryMemberOrderList();
        },
        // 按钮操作
        cancelOrder(item, index) {
            const ths = this;
            this.currentIdx = index;
            console.log(index);
            ths.disabled = true;
            confirmModal('确认取消订单吗', function() {
                const params = {
                    orderCode: item.orderCode
                };
                ths.$doRequest(
                    {
                        url: '/order/cancelOrder',
                        params: params,
                        before: function() {
                            ths.loading = toastLoading();
                        },
                        complete: function() {
                            clearToastLoading(ths.loading);
                            setTimeout(() => {
                                ths.disabled = false;
                            }, 1200);
                        }

                    },
                    function(data) {
                        Toast({
                            duration: 0,
                            message: '订单已取消'
                        });
                        setTimeout(() => {
                            Toast.clear();
                            ths.pageNum = 1;
                            ths.queryMemberOrderList();
                        }, 800);
                    }
                );
            }, function() {
                ths.disabled = false;
            });
        },
        collectGoods(item) {
            const ths = this;
            ths.ESVStorage.putSavedValue('productData', item);
            confirmModal('确定收货吗？', function() {
                const params = {
                    orderCode: item.orderCode
                };
                ths.$doRequest(
                    {
                        url: '/order/confirmOrder',
                        params: params,
                        before: function() {
                            ths.loading = toastLoading();
                        },
                        complete: function() {
                            clearToastLoading(ths.loading);
                        }
                    },
                    function(data) {
                        Toast.success('收货成功');
                        ths.esvOpenPage('OPDeliverySuccess');
                    }
                );
            });
        },
        // 提醒发货
        shipmentClick(item) {
            const ths = this;
            const params = {
                orderCode: item.orderCode
            };
            this.$doRequest(
                {
                    url: '/order/remindDelivery',
                    params: params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    Toast.success('提醒成功');
                }
            );
        },
        // 查看物流
        queryLogistics(item) {
            const ths = this;
            ths.ESVStorage.putSavedValue('orderCode', item.orderCode);
            ths.esvOpenPage({ name: 'OPLogisticsList', params: { orderCode: item.orderCode } });

            // ths.$doRequest(
            //     {
            //         url: '/order/queryLogisticsOrderList',
            //         params: params,
            //         before: function() {
            //             ths.loading = toastLoading();
            //         },
            //         complete: function() {
            //             clearToastLoading(ths.loading);
            //         }
            //     },
            //     function(data) {
            //         ths.ESVStorage.putSavedValue('logList', data.result);
            //         ths.esvOpenPage('OPLogisticsList');
            //     }
            // );
        },
        paymentClick(item) {
            const orderInfo = {
                orderCode: item.orderCode,
                sumPayAmount: item.payAmount
            };
            this.ESVStorage.putSavedValue('orderInfo', orderInfo);
            // console.log(item);
            let channelType = 'WECHAT';
            this.ESVStorage.getSessionValue('channelType', (data) => {
                channelType = data;
            });
            if (channelType === 'APP') {
                this.esvOpenPage({ name: 'OPPayorder' });
            } else {
                this.getIndexUrl();
            }
        },
        openEvaluate(item) {
            this.ESVStorage.putSavedValue('productData', item);
            this.esvOpenPage('OPEvaluate');
        },
        // 二次鉴权
        getIndexUrl() {
            const params = {
                url: '#/OPPayorder?esvOAuthUrlIndex=1'
            };
            this.$doRequest(
                {
                    url: '/oauth/getActualOAuthUrl',
                    params: params
                },
                function(data) {
                    // sessionStorage.setItem('isIndex', '1');
                    window.location.href = data.result;
                }
            );
        },
        // 查询详情
        queryMemberOrderDetail(orderCode) {
            const ths = this;
            const params = {
                orderCode: orderCode
            };
            ths.$doRequest(
                {
                    url: '/order/queryMemberOrderDetail',
                    params: params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    // ths.ESVStorage.putSavedValue('dataDetails', data.result);
                    ths.setOrderDetails({ orderDetails: data.result });
                    ths.esvOpenPage('OPOrderDetails');
                }
            );
        },
        openOrderDetails(orderCode) {
            this.queryMemberOrderDetail(orderCode);
        },
        // 删除订单
        deleteOrder(item) {
            const ths = this;
            confirmModal('确定删除订单吗？', function() {
                const params = {
                    orderCode: item.orderCode
                };
                ths.$doRequest(
                    {
                        url: '/order/deleteMemberOrder',
                        params: params,
                        before: function() {
                            ths.loading = toastLoading();
                        },
                        complete: function() {
                            clearToastLoading(ths.loading);
                        }
                    },
                    function(data) {
                        Toast({
                            duration: 0,
                            message: '订单删除成功'
                        });
                        setTimeout(() => {
                            Toast.clear();
                            ths.pageNum = 1;
                            ths.queryMemberOrderList();
                        }, 800);
                    }
                );
            });
        },
        evaluate() {
            this.esvOpenPage('OPEvaluate');
        }
    }
};
</script>
<style lang="scss" scoped>
.orderBox {
    height: 100%!important;
    .orderList {
        margin-top: 12px;
        background: #fff;
        .van-card {
            height: 110px;
            margin-top: 10px;
        }
        .orderType {
            padding: 8px 12px;
            text-align: right;
            border-bottom: 1px solid #e3e2e2;
            img{
                float: left;
                 width:18px;
                 margin-right:10px;
            }
            .type{
                float:left;
            }
            .status{
                color: #ee2e50;
            }
        }
        .paymentMessage {
            text-align: right;
            padding: 10px 12px;
            border-bottom: 1px solid #e3e2e2;
        }
        .buttonStyle {
            div {
                text-align: right;
                padding: 4px;
            }
        }
    }
}
.mt20 {
    margin-top: 20px;
}
.numP {
    .span1 {
        float: left;
        color: #ee2e50;
    }
    .span2 {
        float: right;
        color: #999;
    }
}
.refreshBox {
    height: 100%;
    overflow: auto;
    padding-bottom: 0;
}
.noListStyle {
    text-align: center;
    img {
        width: 203px;
    }
    p {
        color: #999;
        padding-top: 20px;
        text-align: center;
    }
}
.orderList {
    .descP {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1 !important;
        -webkit-box-orient: vertical;
        margin-top: 2px;
        color: #999;
    }
}
.kdImg{
    margin-top:3px;
}
.floatLeft{
    float: left;
}
.floatRight{
    float: right;
}
.divBox{
    overflow: hidden;
}
.zyStyle{
    background: rgba(238,46,80,0.20);
    border-radius: 7px;
    padding:0 7px;
    color:#EE2E50;
}
</style>
